import type { ApiError } from "../auth/api";
import type { ParentStringKey } from "./strings";

export { needsFreshSignIn } from "../auth/errors";

/** The message for a failed parent call that is not a stale session. */
export function errorKey(error: ApiError): ParentStringKey {
  switch (error.kind) {
    case "offline":
      return "parent.offline";
    case "rate_limited":
      return "parent.rateLimited";
    case "http":
      return "parent.error";
  }
}
